import FactureAssuranceSociete from '@/components/comptable/creance/creance-factures/facture-assurance-societe'
import CreanceAssurance from '@/components/comptable/creance/creance-factures/creance-assurance'

export default {
    name: 'creance-factures',
    components: {
        FactureAssuranceSociete, CreanceAssurance
    },
    props: [],
    data() {
        return {
            is_facture: true,
            user_info: {}
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.user_info = {
            name: this.userCredentials.user.name,
            user_id: this.userCredentials.user.id,
            titre: this.userCredentials.user.titre
        }
    },

    methods: {
        toggleView() {
            this.is_facture = !this.is_facture
        },

        setInvoicePrint(invoice_data) {
            this.$emit('emitPrinFactureAssurance', invoice_data)
        }
    }
}